var React = require('react');

function ExclamationMarkSolid (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M7.1,1.3h1.8c0.9,0,1.7,0.8,1.5,1.8L9.6,9.7c-0.2,0.6-0.8,1-1.5,1h0c-0.7,0-1.2-0.4-1.5-1L5.5,3.1\n\tC5.4,2.2,6.1,1.3,7.1,1.3z","key":0}),React.createElement("circle",{"fill":"currentColor","cx":"8","cy":"13.3","r":"1.4","key":1})]);
}

ExclamationMarkSolid.displayName = "ExclamationMarkSolid";

ExclamationMarkSolid.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = ExclamationMarkSolid;

ExclamationMarkSolid.default = ExclamationMarkSolid;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/exclamationMarkSolid.svg
// module id = ../icon/src/icons/exclamationMarkSolid.svg
// module chunks = 0